// src/pages/Connections.jsx
import React, { useState } from 'react';
import './Connections.css';

const Connections = () => {
 // Datos de ejemplo
  const connectionsList = [
    {
      id: 1,
      name: "WhatsApp Empresa",
      clientName: "Corporación ABC",
      provider: "WhatsApp",
      type: "social",
      status: "active",
      lastConnected: "hace 5 minutos"
    },
    {
      id: 2,
      name: "Email Marketing",
      clientName: "Distribuidora XYZ",
      provider: "Gmail",
      type: "email",
      status: "active",
      lastConnected: "hace 1 hora"
    },
    {
      id: 3,
      name: "Messenger Support",
      clientName: "Tienda Online",
      provider: "Facebook",
      type: "social",
      status: "inactive",
      lastConnected: "hace 3 días"
    },
    {
      id: 4,
      name: "SMS Notifications",
      clientName: "Clínica Médica",
      provider: "Twilio",
      type: "app",
      status: "active",
      lastConnected: "hace 30 minutos"
    },
    {
      id: 5,
      name: "Chat Web",
      clientName: "Hotel Estrella",
      provider: "LiveChat",
      type: "app",
      status: "active",
      lastConnected: "hace 10 minutos"
    },
    {
      id: 6,
      name: "Soporte por Telegram",
      clientName: "Instituto Educativo",
      provider: "Telegram",
      type: "social",
      status: "inactive",
      lastConnected: "hace 1 semana"
    }
  ];
  const [searchTerm, setSearchTerm] = useState('');
  const [typeFilter, setTypeFilter] = useState('all');
  const [statusFilter, setStatusFilter] = useState('all');
const [connections, setConnections] = useState(() => {
  const localStorageConnections = localStorage.getItem('userInfo');
  if (localStorageConnections) {
    const userInfo = JSON.parse(localStorageConnections);
    return userInfo.connections || [];
  }
  return [];
});
const [allConnections, setAllConnections] = useState(() => {
  const allconn = localStorage.getItem('connections');
  console.log(allconn);
  return allconn ? allconn : [];
});

// Form state
const [formData, setFormData] = useState({
  name: '',
  clientName: '',
  provider: '',
  type: '',
  status: 'active',
  config: {
    api_key: '',
    api_secret: '',
    webhook_url: ''
  }
});

// Handle form input changes
const handleInputChange = (e) => {
  const { name, value } = e.target;
  if (name.includes('.')) {
    const [parent, child] = name.split('.');
    setFormData(prev => ({
      ...prev,
      [parent]: {
        ...prev[parent],
        [child]: value
      }
    }));
  } else {
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  }
};

// Handle form submission
const handleSubmit = (e) => {
  e.preventDefault();
  
  // Create new connection
  const newConnection = {
    id: Date.now(),
    ...formData,
    lastConnected: 'hace 1 minuto'
  };
  
  // Update connections state
  setConnections(prev => [...prev, newConnection]);
  
  // Save to localStorage
  localStorage.setItem('connections', JSON.stringify([...connections, newConnection]));
  
  // Close modal and reset form
  closeModal();
  setFormData({
    name: '',
    clientName: '',
    provider: '',
    type: '',
    status: 'active',
    config: {
      api_key: '',
      api_secret: '',
      webhook_url: ''
    }
  });
};

  
 
  // Funciones para filtrado
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleTypeChange = (e) => {
    setTypeFilter(e.target.value);
  };

  const handleStatusChange = (e) => {
    setStatusFilter(e.target.value);
  };

  // Aplicar filtros
  const filteredConnections = connections.filter(connection => {
    // Filtro por búsqueda
    const matchesSearch = connection.name.toLowerCase().includes(searchTerm.toLowerCase()) || 
                           connection.clientName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                           connection.provider.toLowerCase().includes(searchTerm.toLowerCase());
    
    // Filtro por tipo
    const matchesType = typeFilter === 'all' || connection.type === typeFilter;
    
    // Filtro por estado
    const matchesStatus = statusFilter === 'all' || connection.status === statusFilter;
    
    return matchesSearch && matchesType && matchesStatus;
  });

  // Modal para nueva conexión
  const [showModal, setShowModal] = useState(false);
  
  const openModal = () => {
    setShowModal(true);
  };
  
  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <div className="connections-container">
      <div className="connections-header">
        <h1>Conexiones</h1>
        <button style={{display: 'none'}} className="create-connection-btn" onClick={openModal}>+ Nueva Conexión</button>
      </div>
      
      <div className="connection-filters">
        <input 
          type="text" 
          placeholder="Buscar conexión..." 
          className="search-input" 
          value={searchTerm}
          onChange={handleSearchChange}
        />
        <select 
          className="filter-select"
          value={typeFilter}
          onChange={handleTypeChange}
        >
          <option value="all">Todos los tipos</option>
          <option value="email">Email</option>
          <option value="social">Social Media</option>
          <option value="app">Aplicación</option>
        </select>
        <select 
          className="filter-select"
          value={statusFilter}
          onChange={handleStatusChange}
        >
          <option value="all">Todos los estados</option>
          <option value="active">Activo</option>
          <option value="inactive">Inactivo</option>
        </select>
      </div>
      
      {connections.length === 0 ? (
        <div className="no-results">
          <p>No se encontraron conexiones que coincidan con los filtros.</p>
        </div>
      ) : (
        <div className="connections-grid">
          {connections.map(connection => (
            <div key={connection.id} className="connection-card">
              <div className="connection-card-header">
                <h3>{connection.name}</h3>
                <span className={`status-indicator ${connection.status}`}>
                 
                {connection.status === 'active' ? '🟢' : '🔴'}
                </span>
              </div>
              
              <div className="connection-card-body">
                <div className="connection-card-info">
                  <p><strong>Cliente:</strong> {connection.clientName}</p>
                  <p><strong>Proveedor:</strong> {connection.provider}</p>
                  <p>
                    <strong>Tipo:</strong> 
                    <span className={`type-badge ${connection.type}`}>
                      {connection.type === 'email' && 'Email'}
                      {connection.type === 'social' && 'Social Media'}
                      {connection.type === 'app' && 'Aplicación'}
                    </span>
                  </p>
                  <p><strong>Última Conexión:</strong> {connection.lastConnected}</p>
                </div>
              </div>
              
              <div className="connection-card-footer">
              
                <button className="action-btn delete-btn">Guidelines</button>
              </div>
            </div>
          ))}
        </div>
      )}
      
      {/* Modal para Nueva Conexión */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h2>Nueva Conexión</h2>
              <button className="close-modal-btn" onClick={closeModal}>&times;</button>
            </div>
            <div className="modal-body">
              <form className="connection-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Nombre de la Conexión</label>
                  <input 
                    type="text" 
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Ej: WhatsApp Marketing" 
                  />
                </div>
                
                <div className="form-row">
                  <div className="form-group">
                    <label>Cliente</label>
                    <select 
                      name="clientName"
                      value={formData.clientName}
                      onChange={handleInputChange}
                    >
                      <option value="">Seleccionar Cliente</option>
                      <option value="Corporación ABC">Corporación ABC</option>
                      <option value="Distribuidora XYZ">Distribuidora XYZ</option>
                      <option value="Tienda Online">Tienda Online</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Proveedor</label>
                    <select 
                      name="provider"
                      value={formData.provider}
                      onChange={handleInputChange}
                    >
                      {allConnections && allConnections.map(connection => (
                        <option value={connection.provider}>{connection.provider}</option>
                      ))}
                  </select>
                  </div>
                </div>
                
                <div className="form-group">
                  <label>Tipo</label>
                  <select 
                    name="type"
                    value={formData.type}
                    onChange={handleInputChange}
                  >
                    <option value="">Seleccionar Tipo</option>
                    <option value="email">Email</option>
                    <option value="social">Social Media</option>
                    <option value="app">Aplicación</option>
                  </select>
                </div>
                
                <div className="connection-config">
                  <h3>Configuración de Proveedor</h3>
                  <div className="config-fields">
                    <div className="form-group">
                      <label>API Key</label>
                      <input 
                        type="text" 
                        name="config.api_key"
                        value={formData.config.api_key}
                        onChange={handleInputChange}
                        placeholder="Introduce API Key" 
                      />
                    </div>
                    <div className="form-group">
                      <label>API Secret</label>
                      <input 
                        type="password" 
                        name="config.api_secret"
                        value={formData.config.api_secret}
                        onChange={handleInputChange}
                        placeholder="Introduce API Secret" 
                      />
                    </div>
                    <div className="form-group">
                      <label>URL del Webhook</label>
                      <input 
                        type="text" 
                        name="config.webhook_url"
                        value={formData.config.webhook_url}
                        onChange={handleInputChange}
                        placeholder="https://..." 
                      />
                    </div>
                  </div>
                </div>
                
                <div className="form-actions">
                  <button type="button" className="cancel-btn" onClick={closeModal}>Cancelar</button>
                  <button type="submit" className="save-btn">Guardar Conexión</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Connections;